import * as httpClient from "./httpClient";

export async function getAppTitle() {
  return await httpClient.get("/title?origin=" + (window.location.hostname.match(/.*(?=media)/) || [""])[0]);
}